import axios from 'utils/requestHelper';

const fetchAll = (params) => axios.get('v1/clients/invoices', { params });
/* Counted by the API rather than summed from the listing above, which is paged -
   a client with more waiting orders than fit on one page would be undercounted. */
const fetchPendingSummary = () => axios.get('v1/clients/invoices/pending_summary');

const InvoiceAPI = {
  fetchAll,
  fetchPendingSummary,
};

export default InvoiceAPI;
